{
  "messageErrFetchingData":"Falha na comunicação.",
  "deatilErrFetchingDataConsult":"Houve falha na comunicação. Tente novamente mais tarde.",
  "tempoExcedido":"Tempo Excedido",
  "tempoExcedidoPag":"Você atingiu o limite de 05 minutos sem executar nenhuma ação.",
  "tempExcedidoSelectAccount":"Você atingiu o limite de 05 minutos sem executar nenhuma ação.",
  "failValidlab":"Falha na Validação",
  "failValideDet":"Dados de autenticação não conferem com os informados na Iniciadora de Pagamentos. Inicie a solicitação de consentimento novamente."
}